module.exports = __webpack_public_path__ + "static/media/plain.4b00be73.png";